import React from 'react';
import classNames from 'classnames';
import styles from './CardTitle.module.scss';
import Icon from '../Icon/Icon';

export interface CardTitleProps {
  label: string;
  isUnderlined?: boolean;
  hasNextArrow?: boolean;
  smallLabel?: boolean;
}

const CardTitle: React.FC<CardTitleProps> = ({
  label,
  isUnderlined = false,
  hasNextArrow = false,
  smallLabel = false,
}) => {
  return (
    <div className={classNames(styles.root, { [styles.underlined]: isUnderlined }, 'flex items-center gap-x-2')}>
      <span
        className={classNames('text-full', {
          'typo-text-16--bold': !smallLabel,
          'typo-text-12--bold': smallLabel,
        })}>
        {label}
      </span>
      {hasNextArrow && <Icon name="arrowRight" width={20} height={20} />}
    </div>
  );
};

export default CardTitle;
